import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-notification",
  "use": "icon-soc-notification-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-notification\">\r\n  <!-- 通知中心：铃铛线框 + 未读点 -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"M512 160c-48 0-96 40-96 96v32c-160 32-256 160-256 304v96l-64 96v48h768v-48l-64-96v-96c0-144-96-272-256-304v-32c0-56-48-96-96-96z\" />\r\n    <path d=\"M416 864c16 48 48 80 96 80s80-32 96-80\" />\r\n    <circle cx=\"736\" cy=\"288\" r=\"64\" fill=\"currentColor\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-notification.svg
// module id = wYAu
// module chunks = 546